module.exports = "<div class=\"row no-margin\">\n  <cat-input-parameter-list\n    [parameters]=\"projectParameters\"\n    [parentTitle]=\"projectUnit?.name\"\n    (afterUpdate)=\"refreshResource($event)\">\n  </cat-input-parameter-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/landing-pages/project-parameters-landing/project-parameters-landing.component.html
// module id = ../../../../../src/app/modules/project-details/components/landing-pages/project-parameters-landing/project-parameters-landing.component.html
// module chunks = main